
const PAGE = [
  {
    "content": `Historia`
  },
  { 
    "type": "div",
    "className": "itemHeaderText",
    "content": `Finalizado: <span style="font-weight:400">Ofertas de planes de tratamiento</span>`
  },
  { 
    "type": "div",
    "className": "itemHeaderText",
    "content": `Finalizado: <span style="font-weight:400">Planes de tratamiento completo</span>`
  }
];




  
export default PAGE;